import React from "react"
import {Box, Breadcrumbs, Container, Stack, Typography} from "@mui/material";
import ServiceItemPlaceholder from "../service/ServiceItemPlaceholder";
import {useServiceList} from "../service/hook/useServiceList";
import ServiceItem from "../service/ServiceItem";
import {withServiceListContext} from "../service/state/serviceContext"

const AdviceServiceRelateList = () => {
    const {isLoading, services} = useServiceList()

    return <Container maxWidth="lg" style={{marginTop: '29px'}} id="service-list">
        <Box>
            <Typography variant={'h3'} sx={{color:'#DD809D'}}>Services associés</Typography>
            <br/>
            <Stack
                direction="row"
                flexWrap="wrap"
                gap="20px"
                marginBottom="20px"
                justifyContent={'center'}
            >
                {
                    isLoading && Array(6).fill("").map( () => <ServiceItemPlaceholder/> )
                }
                {
                    !isLoading && services.map( (service, index) => <ServiceItem {...service} key={index} addMargin={services.length < 3 } /> )
                }
            </Stack>
        </Box>
    </Container>
}

export default withServiceListContext(AdviceServiceRelateList)
